"use client";

import { useState } from "react";
import { METRICS_EVENTS } from "@cede/types";
import { CEDE_CEX_SIGN_UP_URLS, CEDE_CEXS } from "@cede/utils";
import { CompletedBadge } from "./CompletedBadge";
import { Button } from "@/components/ui/button";
import { useMetricsEvents } from "@/hooks/data/useMetricsEvents";
import { useHubUser } from "@/hooks/user/useHubUser";
import { ExternalLink } from "lucide-react";

const REFERRAL_URL = CEDE_CEX_SIGN_UP_URLS[CEDE_CEXS.CRYPTOCOM];

type CreateAccountProps = {
  onAccountCreated: (created: boolean) => void;
};

export const CreateAccount = ({ onAccountCreated }: CreateAccountProps) => {
  const { trackEvent } = useMetricsEvents();
  const { hubUser } = useHubUser();
  const [linkClicked, setLinkClicked] = useState(false);
  const [accountCreated, setAccountCreated] = useState(false);

  const handleSignupClick = () => {
    trackEvent(METRICS_EVENTS.CRYPTO_COM_REFEREE_SIGNUP_CLICKED, {
      wallet_address: hubUser?.defiAddress ?? null,
    });
    window.open(REFERRAL_URL, "_blank", "noopener,noreferrer");
    setLinkClicked(true);
  };

  const handleConfirmCreated = () => {
    setAccountCreated(true);
    onAccountCreated(true);
  };

  if (accountCreated) {
    return <CompletedBadge label="Confirmed" />;
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="primary"
        size="small"
        leftIcon={<ExternalLink className="h-3.5 w-3.5" />}
        onClick={handleSignupClick}
      >
        Sign Up
      </Button>
      {linkClicked && (
        <Button variant="outline" size="small" onClick={handleConfirmCreated}>
          I&apos;ve created my account
        </Button>
      )}
    </div>
  );
};
